<div class="wrapper-backdrop">
    <router-outlet></router-outlet>
</div>